import { render } from "./PopUpNotifikasi.vue?vue&type=template&id=782d0356"
import script from "./PopUpNotifikasi.vue?vue&type=script&lang=js"
export * from "./PopUpNotifikasi.vue?vue&type=script&lang=js"

import "./PopUpNotifikasi.vue?vue&type=style&index=0&id=782d0356&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__